export default store => next => action => {
  let nextAction = next(action)

  if (!action.error || !action.error.status) {
    return nextAction
  }

  let errorAction
  if (action.error.status >= 400 && action.error.status < 600) {
    errorAction = {
      type: 'API_ERROR',
      status: action.error.status,
      message: action.error.message,
      name: action.error.name,
      notify: {
        type: 401 && 'warning' || 'error', // 401 gives a login warning
        message: `${action.error.status}: ${action.error.message}`,
        title: action.error.name
      }
    }
  }

  if (!errorAction.message && (!errorAction.notify || !errorAction.notify.message)) {
    switch (action.error.status) {
      case 401:
        errorAction = {
          type: 'MISSING_LOGIN_TOKEN',
          redirectTo: '/login',
          notify: {
            type: 'warning',
            message: '401: You must login to continue.'
          }
        }
        break
      case 403:
        errorAction = {
          type: 'MISSING_PERMISSIONS',
          notify: {
            type: 'error',
            message: '403: You do not have permission to access this.'
          }
        }
        break
      case 404:
        errorAction = {
          type: 'MISSING_PAGE',
          notify: {
            type: 'error',
            message: '404: There was an issue processing your request.'
          }
        }
        break
    }
  }

  // if the current location is at login, don't redirect to login again (so nextPath stays intact, etc)
  const willRedirect = store && store.getState() && store.getState().router &&
    store.getState().router.locationBeforeTransitions &&
    store.getState().router.locationBeforeTransitions.pathname === '/login'

  if (willRedirect && errorAction.redirectTo) delete errorAction.redirectTo
  if (errorAction.type) store.dispatch(errorAction)

  return nextAction
}



// WEBPACK FOOTER //
// ./src/middleware/apiError.js